import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"errors\" role=\"dialog\">\n  {{yield}}\n</div>\n")